import { supabase } from "@/integrations/supabase/client";
import { handleSupabaseFunctionError } from "@/utils/supabaseFunctionsError";
import type {
  ActualizeazaTargetareContactRequest,
  ActualizeazaTargetarePersoanaRequest,
  GetTargetareContacteStatsResponse,
  ImportaTargetareContacteRequest,
  ImportaTargetareContacteResponse,
  ProgrameazaTargetareDescoperireRequest,
  ProgrameazaTargetareDescoperireResponse,
  ProgrameazaTargetareImbogatireRequest,
  ProgrameazaTargetareImbogatireResponse,
  RuleazaTargetareDescoperireRequest,
  RuleazaTargetareDescoperireResponse,
  SalveazaTargetareContactRequest,
  SalveazaTargetareContactResponse,
  SalveazaTargetareExcludereRequest,
  SalveazaTargetarePersoanaRequest,
  SalveazaTargetarePersoanaResponse,
  StergeTargetarePersoanaRequest,
  SalveazaTargetareExcludereResponse,
  StergeTargetareContactRequest,
} from "@/api/types/targetareContacte";

function assertSuccess(data: unknown, endpoint: string): void {
  if (
    !data ||
    typeof data !== "object" ||
    (data as { success?: unknown }).success !== true
  ) {
    throw new Error(`Răspuns invalid de la ${endpoint}`);
  }
}

export async function salveazaTargetareContact(
  request: SalveazaTargetareContactRequest
): Promise<SalveazaTargetareContactResponse> {
  const { data, error } = await supabase.functions.invoke(
    "api/targetare/contacte",
    { method: "POST", body: request }
  );
  await handleSupabaseFunctionError(error);
  assertSuccess(data, "targetare/contacte");
  return data;
}

export async function actualizeazaTargetareContact(
  request: ActualizeazaTargetareContactRequest
): Promise<SalveazaTargetareContactResponse> {
  const { data, error } = await supabase.functions.invoke(
    `api/targetare/contacte/${request.id}`,
    { method: "PATCH", body: { stare: request.stare, note: request.note } }
  );
  await handleSupabaseFunctionError(error);
  assertSuccess(data, "targetare/contacte");
  return data;
}

export async function stergeTargetareContact(
  request: StergeTargetareContactRequest
): Promise<{ success: boolean; data: boolean }> {
  const { data, error } = await supabase.functions.invoke(
    `api/targetare/contacte/${request.id}`,
    { method: "DELETE" }
  );
  await handleSupabaseFunctionError(error);
  assertSuccess(data, "targetare/contacte");
  return data;
}

export async function salveazaTargetarePersoana(
  request: SalveazaTargetarePersoanaRequest
): Promise<SalveazaTargetarePersoanaResponse> {
  const { data, error } = await supabase.functions.invoke(
    "api/targetare/persoane",
    { method: "POST", body: request }
  );
  await handleSupabaseFunctionError(error);
  assertSuccess(data, "targetare/persoane");
  return data;
}

export async function actualizeazaTargetarePersoana(
  request: ActualizeazaTargetarePersoanaRequest
): Promise<SalveazaTargetarePersoanaResponse> {
  const { data, error } = await supabase.functions.invoke(
    `api/targetare/persoane/${request.id}`,
    {
      method: "PATCH",
      body: {
        stare: request.stare,
        email: request.email,
        note: request.note,
        functie: request.functie,
      },
    }
  );
  await handleSupabaseFunctionError(error);
  assertSuccess(data, "targetare/persoane");
  return data;
}

export async function stergeTargetarePersoana(
  request: StergeTargetarePersoanaRequest
): Promise<{ success: boolean; data: boolean }> {
  const { data, error } = await supabase.functions.invoke(
    `api/targetare/persoane/${request.id}`,
    { method: "DELETE" }
  );
  await handleSupabaseFunctionError(error);
  assertSuccess(data, "targetare/persoane");
  return data;
}

export async function salveazaTargetareExcludere(
  request: SalveazaTargetareExcludereRequest
): Promise<SalveazaTargetareExcludereResponse> {
  const { data, error } = await supabase.functions.invoke(
    "api/targetare/excluderi",
    { method: "POST", body: request }
  );
  await handleSupabaseFunctionError(error);
  assertSuccess(data, "targetare/excluderi");
  return data;
}

export async function importaTargetareContacte(
  request: ImportaTargetareContacteRequest
): Promise<ImportaTargetareContacteResponse> {
  const { data, error } = await supabase.functions.invoke(
    "api/targetare/contacte/import",
    { method: "POST", body: request }
  );
  await handleSupabaseFunctionError(error);
  assertSuccess(data, "targetare/contacte/import");
  return data;
}

export async function getTargetareContacteStats(): Promise<GetTargetareContacteStatsResponse> {
  const { data, error } = await supabase.functions.invoke(
    "api/targetare/contacte/stats",
    { method: "GET" }
  );
  await handleSupabaseFunctionError(error);
  assertSuccess(data, "targetare/contacte/stats");
  return data;
}

export async function programeazaTargetareDescoperire(
  request: ProgrameazaTargetareDescoperireRequest
): Promise<ProgrameazaTargetareDescoperireResponse> {
  const { data, error } = await supabase.functions.invoke(
    "api/targetare/descoperire/programeaza",
    { method: "POST", body: request }
  );
  await handleSupabaseFunctionError(error);
  assertSuccess(data, "targetare/descoperire/programeaza");
  return data;
}

export async function programeazaTargetareImbogatire(
  request: ProgrameazaTargetareImbogatireRequest
): Promise<ProgrameazaTargetareImbogatireResponse> {
  const { data, error } = await supabase.functions.invoke(
    "api/targetare/imbogatire/programeaza",
    { method: "POST", body: request }
  );
  await handleSupabaseFunctionError(error);
  assertSuccess(data, "targetare/imbogatire/programeaza");
  return data;
}

export async function ruleazaTargetareDescoperire(
  request: RuleazaTargetareDescoperireRequest
): Promise<RuleazaTargetareDescoperireResponse> {
  const { data, error } = await supabase.functions.invoke(
    "api/targetare/descopera",
    { method: "POST", body: request }
  );
  await handleSupabaseFunctionError(error);
  assertSuccess(data, "targetare/descopera");
  return data;
}
